// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_gb-0";